import React from 'react';
import { BEClarity, Checkout } from "be-components";
import { useEffect } from "react";
import { Modal } from "react-native"
import type { ItemOrderProps, TransactionProps } from "../../../src/types";
import { View } from "../../../src/Components/Themed";

type CheckoutHolderProps = {
    visible:boolean,
    account_id?:string
    mode:'desktop'|'mobile',
    insets:{ top:number, bottom:number, left:number, right:number }
    order:ItemOrderProps,
    onClose:() => void,
    onManageAccount:() => void,
    onCompleteOrder:(item_order:ItemOrderProps, transaction:TransactionProps) => void
}
const CheckoutHolder = ({ mode, visible, order, insets, account_id, onClose, onCompleteOrder, onManageAccount }:CheckoutHolderProps) => {


    useEffect(() => {
        if(!visible){ return }
        BEClarity.smartEvent('launch_checkout');
    },[visible])

    return (
        <Modal
            style={{ flex:1 }}
            visible={visible}
            transparent
            animationType={mode=='desktop' ? 'fade' : 'slide'}
        >
            <View type='blur' style={mode=='desktop' ?{ flex:1, justifyContent:'center', alignItems:'center' }:{ flex:1 }}>
                <View float style={mode=='desktop' ?{ flex:1, width:500, maxHeight:750, marginTop:insets.top, marginBottom:insets.bottom, borderRadius:22 }:{ flex:1, marginTop:10 + insets.top, marginBottom:10+insets.bottom, marginLeft:10+insets.left, marginRight:10+insets.right }}>
                <Checkout
                    item_order={order}
                    account_id={account_id}
                    onRequestNewAccount={() => onManageAccount()}
                    onCancel={() => onClose()}
                    onCompleteOrder={onCompleteOrder}
                />
            </View>
            </View>
        </Modal>
    )
}

export default CheckoutHolder